export const SidebarTestId = {
  SidebarContainer: 'sidebar-container',
  SidebarToggle: 'sidebar-toggle',
  SidebarItem: (itemId: string) => `sidebar-item-${itemId}`,
  SidebarItemLabel: (itemId: string) => `sidebar-item-label-${itemId}`,
  SidebarItemLink: (itemId: string) => `sidebar-item-link-${itemId}`,
  SidebarTooltip: 'sidebar-item-tooltip',
};
